import createNamespaceContext from './helper/createNamespaceContext';
export const NOTIFICATIONS_CONTEXT = 'NotificationsCtx';
export const NotificationsAnalyticsContext = createNamespaceContext(NOTIFICATIONS_CONTEXT, 'NotificationsAnalyticsContext');